<template>
  <div>
    <main-layout :selectedMenu="'myHome'">
      <div class="container">
        <asideCom :activityIndex="8"></asideCom>
        <div class="my-content">
          <div class="myOrder">
            <h4>{{ $t("live.我的订单") }}</h4>
          </div>
          <ul class="top">
            <li v-for="item in statusList" :key="item.id">
              <span
                :class="{ active: item.id === status }"
                @click="changeStatus(item.id)"
                >{{ item.text }}</span
              >
            </li>
          </ul>
          <div class="livePayTitle">
            <span class="title1">{{$t('live.商品')}}</span>
            <span class="title2">{{$t('live.单价(元)')}}</span>
            <span class="title6">{{$t('recruit.数量')}}</span>
            <span class="title3">{{$t('live.实付金额(元)')}}</span>
            <span class="title4">{{$t('live.交易状态')}}</span>
            <span class="title5">{{$t('live.操作')}}</span>
          </div>
          <div class="payList" v-if="orderList.length">
            <div class="list" v-for="(item,i) in orderList" :key='i'>
              <div class="listBox">
                <p class="time">
                  {{mydateFormat(item.createTime)}} <span>{{$t('live.订单编号')}}：{{item.orderNo}}</span>
                </p>
                <div class="forOne clearfix">
                  <div class="list1 clearfix" @click="gotoLiveDetail(item)">
                    <img
                      class="liveImg"
                      :src="item.liveResponse.horizontalThumb | imageUrl('',112,112)"
                      alt=""
                      v-if="item.type !== 3"
                    />
                    <img
                      class="liveImg"
                      :src="item.comboType == 1 ? 'https://image.manamana.net/1654584315000_NGSNmkwG':'https://image.manamana.net/1653616954000_SlYUundefinedpVF'"
                      alt=""
                      v-if="item.type == 3"
                    />
                    <div class="liveRight">
                      <p class="title">
                        {{item.type == 3 ? item.recruitComboDomain.comboName : item.liveResponse.title}}
                      </p>
                      <p class="status">{{item.type == 3 ? $t('recruit.套餐') : $t('live.直播')}}</p>
                    </div>
                  </div>
                  <div class="list2">{{item.livePrice}}</div>
                  <div class="list7">{{item.quantity}}</div>
                  <div class="list3">{{item.orderAmount}}</div>
                  <div class="list4" :class="{'closeCol':item.payStatus == 3}">{{payStatus(item.payStatus)}}</div>
                  <div class="list5" v-if="item.payStatus == 0">
                    <div>
                      <p class="title1" @click="gotoPay(item)">{{$t('live.去支付')}}</p>
                      <p class="title2" @click="closePop(2,item.orderNo)">{{$t('live.取消订单')}}</p>
                    </div>
                  </div>
                  <div class="list6" v-if="item.payStatus == 1" @click="closePop(1)">
                     {{$t('live.申请售后')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="noData">{{$t('global.暂无数据')}}</div>
          <pagination
            :totalRecord="totalRecord"
            :pageSize="pageSize"
            :pageIndex="pageIndex"
            @OnCurrentChanged="changePage"
          />
        </div>
      </div>
    </main-layout>
    <div class="popBox" v-if="popShow">
      <div class="box" v-if="popShow1">
        <div class="title">
          {{$t('live.申请售后')}}
          <span @click="hidePop"></span>
        </div>
        <p class="text">{{$t('live.请联系网站底部在线客服或服务热线')}}：021-52998050</p>
      </div>
      <div class="box" v-if="popShow2">
        <div class="title">
          {{$t('live.取消订单')}}
          <span @click="hidePop"></span>
        </div>
        <div class="order_close">
          <p>{{$t('live.是否取消该订单？')}}</p>
          <div class="but clearfix">
            <span class="yes" @click="closeOrder">{{$t('live.是')}}</span>
            <span class="no" @click="hidePop">{{$t('live.否')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import asideCom from "@/components/aside.vue";
import Pagination from "@/components/v2/Pagination";

export default {
  name: "MyOrder",
  metaInfo() {
    return {
      title: this.$t("live.我的订单") + " | MANA"
    };
  },
  data() {
    return {
      orderList: [],
      pageSize: 8,
      pageIndex: 1,
      totalRecord: 0,
      status: 4,
      popShow: false,
      popShow1: false,
      popShow2: false,
      activeOrderNo: null,
      statusList: [
        {
          id: 4,
          text: this.$t("live.全部")
        },
        {
          id: 0,
          text: this.$t("live.待支付")
        },
        {
          id: 1,
          text: this.$t("live.已支付")
        },
        {
          id: 2,
          text: this.$t("live.已退款")
        }
      ]
    };
  },
  components: {
    MainLayout,
    asideCom,
    Pagination
  },
  created() {
    this.init();
    document.body.style.overflow = "";
  },
  methods: {
    init() {
      this.myOrder();
    },
    closePop(type, data) {
      this.popShow = true;
      if (type == 1) {
        this.popShow1 = true;
      }
      if (type == 2) {
        this.popShow2 = true;
      }
      document.body.style.overflow = "hidden";
      this.activeOrderNo = data;
    },
    closeOrder() {
      this.$http
        .post("/api/bytedance/order/cancle/" + this.activeOrderNo)
        .then(res => {
          if (res.code == "OK") {
            this.hidePop();
            this.myOrder();
            this.$message(res.message);
          }
        });
    },
    hidePop() {
      this.popShow = false;
      this.popShow1 = false;
      this.popShow2 = false;
      this.activeOrderNo = null;
      document.body.style.overflow = "";
    },
    changeStatus(id) {
      this.status = id;
      this.pageIndex = 1;
      this.myOrder();
    },
    gotoPay(item) {
      if (item.payStatus) {
        return;
      }
      if (item.type == 3) {
        let params = {
          comboId: item.liveId
        };
        this.$http
          .post("/api/u/recruit/combo/check", params, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.code == "OK") {
              if (res.data.countUnUsed == 2 && res.data.upgrade == 2) {
                var routeData = this.$router.resolve({
                  path:
                    "/live/payDetail?orderNo=" +
                    item.orderNo +
                    "&type=3" +
                    "&id=" +
                    item.liveId +
                    "&quantity=" +
                    item.quantity
                });
                window.open(routeData.href, "_blank");
              }
              if (res.data.upgrade == 1) {
                this.$message(this.$t("recruit.升级套餐请联系客服微信：") + "manamananet")
              }
              if (res.data.countUnUsed == 1) {
                this.$message(this.$t("recruit.您尚有未用完的职位数，请使用完后再购买"))
              }
            }
          });
      } else {
        var routeData = this.$router.resolve({
          path: "/live/payDetail?orderNo=" + item.orderNo + "&type=2"
        });
        window.open(routeData.href, "_blank");
      }
      
    },
    gotoLiveDetail(item) {
      if (item.type == 3) {
        return;
      } else {
        let routeData = this.$router.resolve({
          path: "/live/liveDetail?id=" + item.liveId
        });
        window.open(routeData.href, "_blank");
      }
    },
    payStatus(status) {
      if (status == 0) {
        return this.$t("live.待支付");
      }
      if (status == 1) {
        return this.$t("live.已支付");
      }
      if (status == 2) {
        return this.$t("live.已退款");
      }
      if (status == 3) {
        return this.$t("live.已取消");
      }
    },
    myOrder() {
      const url = `/api/bytedance/order/list`;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        status: this.status
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.orderList = res.data.list;
          this.totalRecord = res.data.totalRecord;
        }
      });
    },
    changePage(val) {
      this.pageIndex = val;
      this.myOrder();
    }
  }
};
</script>

<style lang="stylus"  scoped>
.body{
  background: #FAFAFA;
}
.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;

  table {
    span {
      font-size: 12px;
      color: #999;
    }

    .title {
      font-size: 12px;
      color: #333333;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    a {
      color: #446EEB;
      font-size: 12px;
    }

    button {
      color: #446EEB;
    }
  }

  .color0 {
    color: #999999;
  }

  .color1 {
    color: #EABC2C;
  }

  .color2 {
    color: #4A8F00;
  }

  .color3 {
    color: #E42323;
  }

  .my-content {
    width: 825px;
    padding: 50px 0 40px 0;
    box-sizing: border-box;

    .myOrder {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      h4 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
      }

      a {
        background: #2026CC;
        color: #fff;
        font-size: 16px;
        padding: 5px 10px;
        margin-right: 20px;

        &::before {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url('/static/v2/article/article_write_icon.png') no-repeat;
          background-size: 20px;
          vertical-align: bottom;
          margin-right: 8px;
        }
      }
    }

    .top {
      padding: 20px 0 0;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #E3E3E3;

      li {
        margin-right: 40px;

        span {
          cursor: pointer;
          font-size: 16px;
          color: #999;
          line-height: 40px;
          display: inline-block;
          height: 39px;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;

          &.active {
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333;
            border-bottom: 2px solid #000000;
          }
        }
      }
    }

    .livePayTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #EBEBEB;
      padding: 0 24px 0 20px;
      box-sizing: border-box;
      font-size: 0;

      span {
        font-size: 12px;
        font-weight: 600;
        color: #999999;
        display: inline-block;
      }

      .title1 {
        width: 45%;
      }

      .title2 {
        width: 10%;
        text-align: center;
      }

      .title3 {
        width: 10%;
        text-align: center;
      }

      .title4 {
        width: 12%;
        text-align: center;
      }

      .title5 {
        width: 12%;
        text-align: center;
      }
      .title6 {
        width: 10%;
        text-align: center;
      }
    }

    .payList {
      .list {
        margin-top: 12px;
        padding: 0 24px 0 20px;
        width: 100%;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        height: 138px;

        .listBox {
          .time {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            height: 46px;
            line-height: 46px;
            span{
              margin-left: 20px;
            }
          }

          .forOne {
            .list1 {
              float: left;
              width: 45%;
              cursor: pointer;

              .liveImg {
                float: left;
                width: 56px;
                height: 56px;
                margin-right: 12px;
              }

              .liveRight {
                .title {
                  font-size: 13px;
                  font-weight: 400;
                  color: #0A0A0A;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin-bottom: 16px;
                }

                .status {
                  font-size: 13px;
                  font-weight: 400;
                  color: #666666;
                }
              }
            }

            .list2 {
              float: left;
              width: 10%;
              text-align: center;
              font-size: 13px;
              font-weight: 400;
              color: #0A0A0A;
            }
            .list7 {
              float: left;
              width: 10%;
              text-align: center;
              font-size: 13px;
              font-weight: 400;
              color: #0A0A0A;
            }

            .list3 {
              float: left;
              width: 10%;
              text-align: center;
              font-size: 13px;
              font-weight: 400;
              color: #0A0A0A;
            }

            .list4 {
              float: left;
              width: 12%;
              text-align: center;
              font-size: 13px;
              font-weight: 400;
              color: #333;
            }
            .closeCol {
              color: #B8B8B8;
            }

            .list5 {
              float: left;
              width: 12%;
              text-align: center;
              cursor: pointer;
              margin-top: -7px;
              .title1 {
                width: 90px;
                height: 30px;
                line-height: 30px;
                background: #FC6240;
                font-size: 14px;
                font-weight: 600;
                color: #FFFFFF;
                margin-left: 50%;
                transform: translateX(-50%);
              }

              .title2 {
                font-size: 13px;
                font-weight: 400;
                color: #333;
                margin-top: 8px;
              }
            }
            .list6{
              float: left;
              width: 13%;
              text-align: center;
              cursor: pointer;
              font-size: 13px;
              font-weight: 400;
              color: #333333;
            }
          }
        }
      }
    }
    .noData{
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #909399;
    }
  }
}

.popBox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);

  .box {
    position: absolute;
    width: 380px;
    height: 220px;
    background: #FFFFFF;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #E0E0E0;
      padding: 0 24px;
      position: relative;
      font-size: 16px;
      span {
        position: absolute;
        width: 13px;
        height: 13px;
        background: url('/static/live/close_btn@2x.png') no-repeat;
        background-size: 100% 100%;
        right: 24px;
        top: 22px;
        cursor: pointer;
      }
    }

    .text {
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      text-align: center;
      line-height: 30px;
      padding: 35px 85px 0;
    }

    .order_close {
      padding: 0 40px;

      p {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin: 27px 0 32px;
        text-align: center;
      }

      .but {
        .yes {
          float: left;
          width: 136px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #999999;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          cursor: pointer;
        }

        .no {
          float: right;
          width: 136px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #2026CC;
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/my/account/myOrder.vue